/**
 * src/hooks/useCMSField.ts
 *
 * Thin wrappers over CMSContext for ergonomic per-component use.
 */

import { useCMS, useCMSPage } from '../context/CMSContext';

export { useCMSPage };

/**
 * Returns a single CMS value by dot-path with a typed fallback.
 *
 * @example
 * const headline = useCMSField<string>('home.hero.headline', 'Default headline');
 */
export function useCMSField<T = string>(path: string, fallback: T): T {
  const { get } = useCMS();
  return get<T>(path, fallback);
}

/**
 * Returns the full "global" CMS block (phone, social, nav, etc.)
 */
export function useCMSGlobal() {
  const { data } = useCMSPage('global');
  return data as {
    site_name?: string;
    phone?: string;
    whatsapp_number?: string;
    email?: string;
    waste_licence?: string;
    footer_copyright?: string;
    social?: Record<string, string>;
    nav_links?: { label: string; href: string }[];
  };
}
